document.addEventListener('DOMContentLoaded', () => {
  if(window.location.pathname.includes("/products/")) {
    const loop = setInterval(() => {
      if($(".bss-b2b-btn-buyitnow").length) {
        clearInterval(loop);
        const style = document.createElement('style');
        let contentStyle = '';
        style.type = 'text/css';
        if ($(".bss-b2b-btn-buyitnow").text() === 'Acquista ora') {
            contentStyle = 'shopify-accelerated-checkout { display: none !important; }'
        } else {
            contentStyle = '.bss-b2b-btn-buyitnow {display: none !important; }'
        }
        style.appendChild(document.createTextNode(contentStyle));
        document.head.appendChild(style);
      }
    }, 100)
    setTimeout(() => {
      clearInterval(loop);
    }, 8000)
  }
  setTimeout(() => {
    let parentDiv = document.querySelector('.bss-b2b-rf-submit-button');
    if (parentDiv) {
      let inputElement = parentDiv.querySelector('input');
      
      if (inputElement) {
          inputElement.value = 'Invia';
      }
    }
  }, 500);
  if(window.location.pathname === '/cart'){
    $(".rale-container input[type='checkbox']").on("change", e => {
      BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData)
    })
  }
});
